"use client";

import { useEffect } from "react";

export default function useScrollToTop(slidingMenuOpen: boolean) {
  useEffect(() => {
    if (slidingMenuOpen) {
      window.scrollTo(0, 0);
    }
  }, [slidingMenuOpen]);
}
